export default "__VITE_ASSET__06572a96__"